module.exports = __webpack_public_path__ + "static/media/anbi.b259440a.png";